import React from 'react';

import { isArray } from 'lodash';
import { useRecoilValue } from 'recoil';

import { formTypes } from 'lib/constants/forms/formTypes';
import { iaRa } from 'lib/helpers/utility';
import { usePatientForms } from 'lib/hooks/queries/patients/usePatientForms';
import { usePracticePatientLinks } from 'lib/hooks/queries/practice/usePracticePatientLink';
import { useCheckinUser } from 'lib/hooks/queries/user/useCheckinUser';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import { userState } from 'components/state';

import { DEFAULT_FILTERS, defaultColumns } from './lib/configs';
import { PatientFormsContext } from './lib/context';

const PatientForms = () => {
  const columnDefs = defaultColumns();
  const currentUser = useRecoilValue(userState);
  const { data } = useCheckinUser({});

  const user = { ...currentUser, ...(data?.user || {}), address_object: data?.address };
  const { data: practiceOptions } = usePracticePatientLinks({
    dependencies: [currentUser.id],
    options: {
      enabled: !!currentUser.id,
      select: (response) => iaRa(response?.patientLinks)
    }
  });

  return (
    <PatientFormsContext.Provider value={{ user }}>
      <div className="mt-0 flex h-full flex-col overflow-hidden bg-white">
        <AgTablePage
          defaultColumns={columnDefs}
          defaultFilters={DEFAULT_FILTERS}
          useData={usePatientForms}
          name="forms"
          queryParams={{
            uncompleted: false,
            formTypes,
            practiceOptions: practiceOptions ? practiceOptions : []
          }}
          queryOptions={{ enabled: isArray(practiceOptions), refetchOnMount: 'always' }} // Refetch On Mount always since we need the updated forms to show when coming back from Wizard
          // Im using the loadash function since it will check even if it is and empty array
          // The function "ia()" won't work in this case since it checks length > 0 arrays
        />
      </div>
    </PatientFormsContext.Provider>
  );
};

export default PatientForms;
